(function () {
  'use strict';

  /**
   * Linenatura — Cupón auto-apply
   * Intercepta los clicks en los botones de cupón de Sternify
   * (.st_discount-button) y aplica el código vía /discount/CODE
   * (Shopify pone una cookie de descuento que viaja al checkout).
   * Muestra un toast de confirmación y notifica al carrito.
   */

  // ---------- i18n ----------
  var lang = (document.documentElement.lang || 'es').slice(0, 2).toLowerCase();
  var T = {
    es: {
      applied: '✓ Cupón {code} aplicado al checkout',
      error: 'No se pudo aplicar el cupón. Cópialo manualmente.',
    },
    fr: {
      applied: '✓ Code {code} appliqué au checkout',
      error: "Impossible d'appliquer le code. Copiez-le manuellement.",
    },
    de: {
      applied: '✓ Gutschein {code} an der Kasse angewendet',
      error: 'Gutschein konnte nicht angewendet werden. Bitte manuell kopieren.',
    },
  };
  var t = T[lang] || T.es;

  // ---------- Toast helper ----------
  var toastTimeoutHide = null;
  var toastTimeoutRemove = null;
  function showToast(message, type) {
    var existing = document.querySelector('.ln-discount-toast');
    if (existing) {
      clearTimeout(toastTimeoutHide);
      clearTimeout(toastTimeoutRemove);
      existing.remove();
    }
    var toast = document.createElement('div');
    toast.className = 'ln-discount-toast' + (type === 'error' ? ' ln-discount-toast--error' : '');
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.textContent = message;
    document.body.appendChild(toast);
    requestAnimationFrame(function () {
      toast.classList.add('ln-discount-toast--show');
    });
    toastTimeoutHide = setTimeout(function () {
      toast.classList.remove('ln-discount-toast--show');
    }, 3500);
    toastTimeoutRemove = setTimeout(function () {
      toast.remove();
    }, 4000);
  }

  // ---------- Apply discount via /discount/CODE ----------
  function applyDiscount(code) {
    if (!code) return;
    var url = '/discount/' + encodeURIComponent(code);
    fetch(url, {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'manual',
      cache: 'no-store',
    })
      .then(function () {
        showToast(t.applied.replace('{code}', code));
        // Hint to cart drawer it could refresh next time it opens
        try {
          if (window.PUB_SUB_EVENTS && window.publish) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'ln-discount-apply',
            });
          }
        } catch (e) {}
      })
      .catch(function () {
        showToast(t.error, 'error');
      });
  }

  // ---------- Click delegation ----------
  // Sternify renders <button class="st_discount-button" value="CODE" onclick="copyDiscountCode()">
  // We intercept before its native handler runs.
  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.st_discount-button');
      if (!btn) return;
      var code = btn.value || btn.getAttribute('value') || btn.getAttribute('data-code');
      if (!code) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      applyDiscount(code);
    },
    true // capture phase, run before Sternify's onclick
  );

  // Also expose for manual triggers (e.g. from a custom button via onclick="lnApplyDiscount('CODE')")
  window.lnApplyDiscount = applyDiscount;
})();
